import React, {useState} from 'react';
import {Col, Row} from "antd";
import {Button, Card, FormGroup} from "components/ui";
import {FormInput} from "components/ui/form";
import {translate} from "utils/helpers";
import {BiReset, FiFilter} from "react-icons/all";
import {useWidgetContext} from "context/WidgetContext";

function WidgetFilter(props) {

    const {translateKey, handleQuery} = useWidgetContext();
    const initialFilter = {
        title: ''
    }
    const [filter, setFilter] = useState(initialFilter);
    const [isFilter, setIsFilter] = useState(false);

    const handleFilter = () => {
        const customQuery = {};
        if (filter.title) customQuery.title = filter.title;
        handleQuery(customQuery);
        setIsFilter(true);
    }

    const handleReset = () => {
        setFilter(initialFilter);
        handleQuery(false);
        setIsFilter(false);
    }

    return (
        <Card className="mb-5">
            <div className="filter-box">
                <div className="flex-1">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} lg={24}>
                            <FormGroup
                                label={translate(translateKey + '.Label.Title')}
                            >
                                <FormInput
                                    value={filter.title}
                                    onPressEnter={e => e.trim() ? handleFilter() : false}
                                    onChange={e => setFilter(f => ({...f, title: e}))}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
                <div className="filter-box-buttons lg:pt-[25px]">
                    <Button
                        disabled={!Object.keys(filter).filter(i => filter[i]?.toString()?.trim()).length}
                        onClick={() => handleFilter()}
                        className="filter-box-button"
                        icon={<FiFilter/>}
                    >
                        {translate( 'button.Filter')}
                    </Button>

                    {isFilter > 0 && (
                        <Button
                            onClick={() => handleReset()}
                            className="filter-box-button"
                            property={'red'}
                            icon={<BiReset/>}
                        >
                            {translate( 'button.Reset')}
                        </Button>
                    )}
                </div>
            </div>
        </Card>
    );
}

export default WidgetFilter;
